let apiBaseUrl = "";
let socketUrl = "";
const aiBaseUrl = "";
let siteUrl = "";
const appStage = process.env.REACT_APP_STAGE;
let cloudFrontUrl = "";
let pfrApiUrl = "";
let cookieDomain = "";

if (appStage === "local") {
  siteUrl = "http://localhost:3030";
  apiBaseUrl = "https://insiderodeo-api.test.tetonridge.io/api/v2/";
  socketUrl = "https://pfr-socket.stage.tetonridge.io/";
  cloudFrontUrl = "https://stage-insiderodeo-api.s3.amazonaws.com/assets/share_image/";
  pfrApiUrl = "https://pfr-api.stage.tetonridge.io/api/v1/";
  cookieDomain = "";
} else if (appStage === "dev" || appStage === "stage") {
  siteUrl = "https://rodeopicks-web-v2.stage.tetonridge.io/";
  apiBaseUrl = "https://insiderodeo-api.stage.tetonridge.io/api/v2/";
  socketUrl = "https://pfr-socket.stage.tetonridge.io/";
  cloudFrontUrl = "https://stage-insiderodeo-api.s3.amazonaws.com/assets/share_image/";
  pfrApiUrl = "https://pfr-api.stage.tetonridge.io/api/v1/";
  cookieDomain = ".stage.tetonridge.io";
} else if (appStage === "test") {
  siteUrl = "https://rodeopicks-web-v2.test.tetonridge.io/";
  apiBaseUrl = "https://insiderodeo-api.test.tetonridge.io/api/v2/";
  socketUrl = "https://pfr-socket.stage.tetonridge.io/";
  cloudFrontUrl = "https://stage-insiderodeo-api.s3.amazonaws.com/assets/share_image/";
  pfrApiUrl = "https://pfr-api.test.tetonridge.io/api/v1/";
  cookieDomain = ".test.tetonridge.io";
} else if (appStage === "prod") {
  siteUrl = "https://rodeopicks.profantasyrodeo.com";
  apiBaseUrl = "https://api.insiderodeo.com/api/v2/";
  socketUrl = "https://ws.insiderodeo.com/";
  cloudFrontUrl = "https://production-insiderodeo-api.s3.amazonaws.com/assets/share_image/";
  pfrApiUrl = "https://controlcenter.profantasyrodeo.com/api/v1/";
  cookieDomain = "profantasyrodeo.com";
}

export const API_BASE_URL = apiBaseUrl;
export const SOCKETURL = socketUrl;
export const AI_BASE_URL = aiBaseUrl;
export const SITE_URL = siteUrl;
export const CLOUDFRONT_URL = cloudFrontUrl;
export const PFR_API_URL = pfrApiUrl;
export const COOKIE_DOMAIN = cookieDomain;
